import { render } from "./TierColorField.vue?vue&type=template&id=6d4b4a2d"
import script from "./TierColorField.vue?vue&type=script&lang=js"
export * from "./TierColorField.vue?vue&type=script&lang=js"

import "./TierColorField.vue?vue&type=style&index=0&id=6d4b4a2d&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__